import { useRouteParams } from "$/util/router";
import React from "react";
import CreationDetailSection from "../components/CreationDetailSection";

function CreationDetailPage() {
  const params: { slug?: string; shortId?: string; variant?: string } =
    useRouteParams();
  const variant = Number(params.variant) || 0; // Ensure idx is a int, not string

  if (params.shortId) {
    return (
      <CreationDetailSection shortId={params.shortId} variant={variant} redirect />
    );
  }
  const splitSlug = params.slug.split("-");
  return (
    <CreationDetailSection
      shortId={splitSlug[splitSlug.length - 1]}
      variant={variant}
    />
  );
}

export default CreationDetailPage;
